<template>
  <v-container fluid align-start ma-0 pa-2 class="epms5010-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters class="row__dely">
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="useBtnList"
                  :unUseBtnList="unUseBtnList"
                  @btnNew="btnNew"
                  @btnRetrieve="btnRetrieve(), btnRetrievePo()"
                  @btnSave="btnSave"
                  @btnPrint="btnPrint"
                  @btnPrintDetail="btnPrintDetail"
                  @btnDeleteAll="btnDelete('a')"
                  @btnDeleteSelect="btnDelete('s')"
                  @btnList="btnList"
                  :key="useBtnListKey"
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <i-label :label="'Delivery No :'" />
                      <v-col cols="2">
                        <v-select
                          v-model="delyNo"
                          :items="delyNoList"
                          single-line
                          outlined
                          dense
                          height="32"
                          @change="btnRetrieve(), btnRetrievePo()" />
                      </v-col>
                      <b v-if="whYn === 'Y'" class="pl-2 d-flex align-center" style="height: 30px;">is Already Warehousing</b>

                      <i-label :label="'Delivery Date :'" class="pl-2" />
                      <v-col cols="2">
                        <v-text-field 
                          class="text__dely-dte"
                          dense 
                          outlined 
                          hide-details="auto"
                          readonly
                          height="32"
                          :value="delyDte"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-4">
              <v-col>
                <DxDataGrid
                  :ref="epms5010Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <!-- <DxPager :show-info="false" :visible="false" /> -->
                  <DxPager :visible="false" />
                  <DxEditing :allow-updating="true" />
                  <DxColumn data-field="shipNo" caption="Ship No" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"
                                        cell-template="porNoTmpl" />
                  <template #porNoTmpl="{ data }">
                    {{ `${data.data.porNo}-${data.data.porSeq}` }}
                  </template>
                  <DxColumn data-field="block" caption="Block" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="mact" caption="Activity" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="bomSerno" width="3%" data-type="string" alignment="center" :allow-editing="false"
                                        header-cell-template="serNoTmpl" cell-template="numTmpl" />
                  <template #serNoTmpl>
                    <div>Ser.<br>No</div>
                  </template>
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="uprice" caption="Unit Price" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyQty" caption="Quantity" width="5%" format="#,##0" data-type="number" alignment="right" :allow-editing="whYn !== 'Y'"
                                        :set-cell-value="delyQtyChanged" />
                  <DxColumn data-field="delyAmt" caption="Amount" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="delyVat" caption="VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transFee" caption="Trans. Fee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="transVat" caption="VAT" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        cell-template="numTmpl" />
                  <DxColumn data-field="govFee" width="5%" data-type="string" alignment="right" :allow-editing="false"
                                        header-cell-template="govFeeTmpl" cell-template="numTmpl" />
                   <template #govFeeTmpl>
                    <div>Gov. Fee<br>(U/Price)</div>
                  </template>
                  <template #numTmpl="{ data }">
                    {{ getNumComma(data.value) }}
                  </template>
                  <DxSelection :allow-select-all="false" :show-check-boxes-mode="whYn === 'Y' ? 'none' : 'always'" mode="multiple" />
                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-text-field 
                          v-model="shipNo"
                          dense 
                          outlined 
                          hide-details="auto"
                          height="32"
                        />
                      </v-col>

                      <i-label :label="'POR NO :'" class="pl-2" />
                      <v-col cols="1">
                        <v-text-field 
                          v-model="porNo"
                          dense 
                          outlined 
                          hide-details="auto"
                          height="32"
                        />
                      </v-col>

                      <i-button :text="'Retrieve'" :isCustom="true" :icon="'search'" class="pl-2" @click="btnRetrievePo(), btnRetrieve()" />

                      <i-label :label="'Delivery Plan Date :'" class="pl-2" />
                      <v-col cols="1">
                        <DxDateBox
                          :value="poDelyDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {poDelyDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>

                      <i-button :text="'Make Delivery Note'" :isCustom="true" :icon="'save'" role="btnMakeDeliveryNote" class="pl-2" @click="btnMakeDeliveryNote" />

                      <v-checkbox v-model="isAppend" label="Append Delivery Note" class="pl-2" :disabled="delyNo === 'New' || whYn === 'Y'"
                                              true-value="Y" false-value="N" />

                      <v-checkbox v-if="userGrd === 'A'" v-model="isAdmin" label="Admin" class="pl-2"
                                              true-value="Y" false-value="N" />
                      
                      <i-button :text="'Export Excel'" :isCustom="true" :icon="'excel'" role="btnExportExcel" class="pl-2" @click="btnExportExcel" />
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1 pb-2">
              <v-col>
                <DxDataGrid
                  :ref="epms5010Ref2"
                  :data-source="dataList2" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="rnum" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                  @cellPrepared="cellPrepared2"
                  @editingStart="editingStart2"
                  @exporting="btnExportExcel"    
                >
                  <DxExport :enabled="true" />
                  <DxPaging :enabled="true" :page-size="setPageSize" />
                  <DxPager :show-page-size-selector="false" />
                  <DxEditing :allow-updating="true" />
                  <DxColumn data-field="chk" caption="Select" width="50" data-type="string" alignment="center"
                                        cell-template="chkCell" :allow-editing="false" />
                                        <!-- header-cell-template="chkHeader" -->
									<!-- <template #chkHeader = "{ data: cellInfo }" >
                    <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)" />
                  </template> -->
                  <template #chkCell = "{ data: cellInfo }">
										<DxCheckBox :value="cellInfo.value" :onValueChanged="value => onValueChanged(value, cellInfo)"
                                              />
                                              <!-- :disabled="userGrd !== 'A' && (data.data.canDely === 'N' || (data.data.remainQty * 1) === 0)" -->
                  </template> 
                  <DxColumn data-field="shipNo" caption="Ship No" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNoSeq"  caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  <!--                      cell-template="porNoTmpl" />
                   <template #porNoTmpl="{ data }">
                    {{ `${data.data.porNo}-${data.data.porSeq}` }}
                  </template> -->
                  <DxColumn data-field="block" caption="Block" width="4%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="firSpDlyDte" width="6%" data-type="string" alignment="center" :allow-editing="false"
                                        header-cell-template="firSpDlyDteTmpl" />
                  <template #firSpDlyDteTmpl>
                    <div>Supp.<br>Delivery Date</div>
                  </template>
                  <DxColumn data-field="matlSpec" caption="Material Specification" data-type="string" alignment="left" :allow-editing="false" />
                  <DxColumn data-field="matlUnit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />

                  <DxColumn data-field="poQty" caption="PO Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="uprice" caption="Unit Price" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="whQty" caption="W/H Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="delyQty" caption="Unit" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false"
                                        header-cell-template="delyQtyTmpl" />
                  <template #delyQtyTmpl>
                    <div>Waitting<br>W/H Qty</div>
                  </template>
                  <DxColumn data-field="remainQty" caption="Remain Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="needQty" :visible="makerCd === '12453'" caption="Need Qty" width="6%" format="#,##0" data-type="number" alignment="right" :allow-editing="false" />
                  <DxColumn data-field="needDte" :visible="makerCd === '12453'" caption="Need Date" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="delyQty2" caption="Delivery Qty" width="6%" format="#,##0" data-type="number" alignment="right"
                                        :set-cell-value="delyQty2Changed" />
                  <DxColumn data-field="useDept" caption="Use Dept" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getDelyNoList, getEpms5010DelyList, getEpms5010PoList, epms5010ModDelivery, epms5010DelDelivery, epms5010InsDelivery } from '@/api/view/hip/5/epms5010'
import { getNumComma, toNum, getDateFormat, getCurrentDate, trim } from '@/utils/common.js'
import iButton from '@/components/common/iButton'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import {DxExport } from 'devextreme-vue/data-grid'
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'

export default {
  name: 'epms5010',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    DxExport,
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      makerCd: this.$store.state.user.makerCd,
      epms5010Ref: 'epms5010Ref',
      epms5010Ref2: 'epms5010Ref2',
      setPageSize: 30,
      useBtnListKey: 0,
      useBtnList: ['btnNew', 'btnRetrieve', 'btnSave', 'btnPrint', 'btnPrintDetail', 'btnDeleteAll', 'btnDeleteSelect', 'btnList'],
      unUseBtnList: [],
      useBtnList2: ['btnRetrieve', 'btnMakeDeliveryNote', 'btnExportExcel'],
      delyNo: 'New',
      delyNoList: ['New'],
      delyDte: this.$route.params.delyDte ? this.$route.params.delyDte : '',
      poDelyDte: getCurrentDate(),
      dataList: [],
      dataList2: [],
      whYn: 'N',
      shipNo: '',
      porNo: '',
      isAppend: 'N',
      isAdmin: 'N',
      userGrd: this.$store.state.user.userGrd,
      userId: this.$store.state.user.userId
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms5010Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms5010Ref2)
    },
    searchDelyNo() {
      return this.delyNo === 'New' ? '' : this.delyNo
    }
  },
  methods: {
    init() {
      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)
    },
    async getDelyNoList() {

      // console.log('this.$route.params', this.$route.params)

      const param = {
        makerCd: this.makerCd,
        delyNo: this.$route.params.delyNo ? this.$route.params.delyNo : this.searchDelyNo
      }

      // console.log('getDelyNoListParam', param)

      await getDelyNoList(param).then(res => {
        // console.log('getDelyNoListRes', res)

        const data = [...new Set(res.list.map(row => row.delyNo))]
        
        data.forEach(item => {
          this.delyNoList.push(item)
        })

        if(this.$route.params.delyNo) {
          this.delyNoList.forEach(item => {
            if(item === this.$route.params.delyNo) {
              this.delyNo = item
            }
          })
        }
      })
    },
    setBtnList() {
      if(this.whYn === 'Y') {
        this.unUseBtnList.push('btnSave', 'btnDeleteAll', 'btnDeleteSelect')
      }
      
      this.useBtnListKey++
    },
    btnNew() {
      this.delyNo = 'New'
      this.delyDte = ''
      this.btnRetrieve()
      this.btnRetrievePo()
    },
    async btnRetrieve() {
      this.gridInstance.clearSelection()
      this.dataList = []
      this.delyDte = ''
      this.poDelyDte = getCurrentDate()
      this.whYn = 'N'
      this.isAppend = 'N'
      this.isAdmin = 'N'

      this.openLoading('searching')
      
      const param = {
        makerCd: this.makerCd,
        delyNo: this.searchDelyNo
      }

      // console.log('getEpms5010DelyListRes', param)

      await getEpms5010DelyList(param).then(res => {
        // console.log('getEpms5010DelyListRes', res)

        let data = res.list

        for(let i = 0; i < data.length; i++) {
          data[i].rnum = i + 1
          data[i].orgQty = data[i].delyQty
        }

         this.dataList = data
         if(this.dataList.length > 0) {
           this.delyDte = this.poDelyDte = this.dataList[0].delyDte
           this.whYn = this.dataList[0].whYn
         }

         this.setBtnList()
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnSave() {
      if(!this.searchDelyNo || this.whYn === 'Y' || this.dataList.length === 0) {
        return
      }

      // console.log('btnSave')

      await this.gridInstance.saveEditData()

      for(let i = 0; i < this.dataList.length; i++) {
        const delyQty = this.dataList[i].delyQty
        const orgQty = this.dataList[i].orgQty

        // console.log('delyQty', delyQty)
        // console.log('orgQty', orgQty)

        if(delyQty !== orgQty) {
          this.gridInstance.selectRows(i + 1, true)
        }
      }

      let saveData = await this.gridInstance.getSelectedRowsData()

      // console.log('saveData', saveData)

      if(saveData.length < 1) {
        this.vToastify(this.$t('Data is not changed.'), 'warn')
        return
      }

      this.openLoading('searching')

      saveData.forEach(item => {
        item.userId = this.userId
      })

      epms5010ModDelivery(saveData).then(res => {
        // console.log('btnSaveRes', res)

        const msg = res.body
        if(msg === 'OK') {
          notify(this.$t('Delivery Note is saved.'), 'success', 3000)
          this.btnRetrieve()
          this.btnRetrievePo()
        } else {
          this.vToastify(this.$t('An error has occured while saving delivery note.'), 'warn')
          return
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    btnPrint() {
      if(!this.delyNo) {
        return
      }

      let param = {
        as_dely_no: this.delyNo,
        as_maker_cd: this.makerCd,
        fileName: 'epms5010.jrxml'
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnPrintDetail() {
      if(!this.delyNo) {
        return
      }

      let param = {
        as_res_no: this.delyNo,
        as_maker_cd: this.makerCd,
        fileName: 'epms5010_assy.jrxml'
      }

      // console.log('param', param)

      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(gbn) {
      // console.log('gbn', gbn)

       if(!this.searchDelyNo || this.whYn === 'Y' || this.dataList.length === 0) {
        return
      }

      let question = '?'
      let selectData = await this.gridInstance.getSelectedRowsData()
      if(gbn === 'a') {
        question = 'Do you want to delete all data?'
      } else if(gbn === 's') {
        if(selectData.length < 1) {
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }

        question = 'Do you want to delete selected data?'
      }

      this.vToastifyPrompt(
        this.$t(question),
        'info',
        async current => {
          let delData
          if(gbn === 'a') {
            this.gridInstance.selectAll()
            delData = await this.gridInstance.getSelectedRowsData()
          } else if(gbn === 's') {
            delData = selectData
          }
          
          epms5010DelDelivery(delData).then(res => {
            // console.log('btnDeleteRes', res)

            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Delivery Note is deleted.'), 'success', 3000)
              this.btnRetrieve()
              this.btnRetrievePo()
            } else {
              this.vToastify(this.$t('An error has occured while saving deleting note.'), 'warn')
              return
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    btnList() {
      this.$router.push('/epms5000')
    },
    async btnRetrievePo() {
      this.grid2Instance.clearSelection()
      this.dataList2 = []
      this.isAppend = 'N'

      this.openLoading('searching')

      const param = {
        makerCd: this.makerCd,
        shipNo: trim(this.shipNo).toUpperCase(),
        porNo: trim(this.porNo).toUpperCase(),
        canDely: '',
        remainDay: ''
      }

      if(this.userGrd !== 'A') {
        param.canDely = 'Y'
        param.remainDay = '7'
      } else if(this.isAdmin  === 'Y') {
        param.canDely = ''
        param.remainDay = '9999'
      } else {
        param.canDely = 'Y'
        param.remainDay = '7'
      }

      // console.log('param', param)

      await getEpms5010PoList(param).then(res => {
        // console.log('getEpms5010PoListRes', res)
        
        let data = res.list
        console.log('data', data)
        data.forEach(item => {
          item.chk = false
          item.delyQty2 = 0
          item.porNoSeq = item.porNo + '-' + item.porSeq
        })

        this.dataList2 = data

        // console.log('data', data)
      }).finally(() => {
        this.endLoading()
      })
    },
    async btnMakeDeliveryNote() {
      if(this.dataList2.length < 1) {
        this.vToastify(this.$t('Data not found for delivery.'), 'warn')
        return
      }

      await this.grid2Instance.saveEditData()
      
      let makeData = await this.grid2Instance.getSelectedRowsData()

      makeData = this.$_.filter(makeData, item => {
        return item.delyQty2 > 0
      })

      
      if(makeData.length < 1) {
        this.vToastify(this.$t('Data not selected for delivery.'), 'warn')
        return
      }

      let canSave = true
      let delyNo = ''
      let delyDte = ''
      const vm = this

      await new Promise(function(resolve, reject) {

       
        if(vm.isAppend === 'Y') {
          vm.vToastifyPrompt(
            vm.$t('Do you want to append data?'),
            'info',
            current => {
              delyNo = vm.searchDelyNo
              delyDte = vm.delyDte
              resolve()
            },
            current => {
              canSave = false
              resolve()
            },
            false
          )
        } else {
          const currDate = getCurrentDate()
          delyDte = vm.poDelyDte

          if(delyDte < currDate) {
            vm.vToastify(vm.$t('Invalid delivery date.'), 'warn')
            canSave = false
            resolve()
            return
          }
          
          vm.vToastifyPrompt(
            vm.$t('Do you want to make new delivery note?'),
            'info',
            current => {
              resolve()
            },
            current => {
              canSave = false              
              resolve()
            },
            false
          )
        }
      })
      
      console.log(canSave) 

      if(!canSave) {
        return
      }

      makeData.forEach(item => {
        item.delyNo = delyNo
        item.delyDte = delyDte
        item.userId = this.userId
        item.needDte = item.needDte?.replaceAll("-", "") || item.needDte
      })

      console.log('makeData', makeData)

      this.openLoading()
      epms5010InsDelivery(makeData).then(async res => {
        // console.log('btnMakeRes', res)

        const resMsg = res.map.msg
        const resDelyNo = res.map.delyNo

        if(resMsg === 'OK') {
          notify(this.$t('Make delivery note is completed.'), 'success', 3000)
          await this.getDelyNoList()
          this.delyNo = resDelyNo
          this.btnRetrieve()
          this.btnRetrievePo()
        } else {
          this.vToastify(this.$t(resMsg), 'warn')
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    delyQtyChanged(newData , value , currData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      
      // console.log('currData', currData)

      const delyQty = val
      const remainQty = toNum(currData.remainQty)
      const uprice = toNum(currData.uprice)
      const tprice = toNum(currData.tprice)

      if(delyQty > remainQty) {
        this.vToastify(this.$t('Delivery Quantity is greater than remain quantity.'), 'warn')
      } else {
        newData.delyQty = val

        const quotAmt = newData.delyQty * uprice
        const transFee = newData.delyQty * tprice
        newData.delyAmt = quotAmt
        newData.transFee = transFee
      }
    },
    getNumComma(val) {
      return getNumComma(val)
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    delyQty2Changed(newData , value , currData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0

      const delyQty = val
      const remainQty = toNum(currData.remainQty)

      if(delyQty > remainQty) {
        this.vToastify(this.$t('Delivery Quantity is greater than remain quantity.'), 'warn')
        newData.delyQty2 = 0
      } else {
        newData.delyQty2 = val
      }
    },
    editingStart2(e) {
      // console.log('e', e)
      if(e.column.dataField === 'delyQty2') {
        if(this.userGrd !== 'A' && (e.data.canDely === 'N' || Number(e.data.remainQty) === 0)) {
          e.cancel = true
        }
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'header' && e.column.command === 'select') {
        e.cellElement.innerText = 'Select'
      }
    },
    cellPrepared2(e) {
      if(e.rowType === 'data' && e.rowIndex >= 0) {
        if(e.column.dataField === 'delyQty2') {
          // console.log('e', e)
          if(this.userGrd !== 'A' && (e.data.canDely === 'N' || Number(e.data.remainQty) === 0)) {
            e.cellElement.classList.add('cancel-editable-cell')
          }
        }
      }
    },
    async onValueChanged(value, cellInfo) {
      console.log('value', value)
      //   console.log('cellInfo', cellInfo)

      // if(cellInfo.rowType === 'header') {
      //   for(let i = 0; i < this.dataList2.length; i++) {
      //     this.dataList2[i].chk = value.value

      //     if(value.value) {
      //       if(this.userGrd !== 'A' && (cellInfo.data.canDely === 'N' || (cellInfo.data.remainQty * 1) === 0)) {
      //         this.grid2Instance.selectRows(i + 1, false)
      //       } else {
      //         this.grid2Instance.selectRows(i + 1, true)
      //       }
      //     } else {
      //       this.grid2Instance.deselectAll()
      //     }
      //   }
      // } else {
      if(cellInfo.rowType === 'data') {
        // this.grid2Instance.cellValue(cellInfo.rowIndex, 'chk', value.value)
        this.dataList2[cellInfo.rowIndex + (this.setPageSize * this.grid2Instance.pageIndex())].chk = value.value
        
        if(value.value) {
          await this.grid2Instance.selectRows([cellInfo.key], true)
          // if(this.makerCd === "12453" &&  cellInfo.data.shipNo !== "H-3250" && cellInfo.data.useDeptCd !== null &&  cellInfo.data.useDeptCd !== "9127" )
          // {
          //   console.log('value22', cellInfo.data)
          //   cellInfo.data.delyQty2 =  cellInfo.data.needQty - cellInfo.data.whQty;   
          //   cellInfo.data.delyQty  =  cellInfo.data.needQty - cellInfo.data.whQty;   
          // }else{
          //   cellInfo.data.delyQty2 =  cellInfo.data.remainQty;   
          //   cellInfo.data.delyQty  =  cellInfo.data.remainQty;  
          // }
          console.log("cellInfo.data : ", cellInfo.data)

          if(Number(cellInfo.data.needQty) > 0 && Number(cellInfo.data.needQty) < Number(cellInfo.data.remainQty))
          {            
            cellInfo.data.delyQty2 =  cellInfo.data.needQty;   
            cellInfo.data.delyQty  =  cellInfo.data.needQty;  
          }else{
            cellInfo.data.delyQty2 =  cellInfo.data.remainQty;   
            cellInfo.data.delyQty  =  cellInfo.data.remainQty;  
          }

        } else {
          cellInfo.data.delyQty2 =  0;   
          cellInfo.data.delyQty =  0;   
          await this.grid2Instance.deselectRows([cellInfo.key])
        }
      }
      // }
    },
    btnExportExcel()
    {
      const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('sheet');

        exportDataGrid({
            component: this.grid2Instance,
            worksheet,
            topLeftCell: { row: 4, column: 1 },
        }).then((cellRange) => {

            // header
            const titleRow = worksheet.getRow(2);
            titleRow.height = 30;
            worksheet.mergeCells(2, 1, 2, 19);

            titleRow.getCell(1).value = 'List POR to make Delevery Note';
            titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
            titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' } ;
           

            const headerRow = worksheet.getRow(4);
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
            let headerRowLength = headerRow._cells.length       

            for(let i = 4; i <= headerRowLength; i++){
              headerRow.getCell(i).fill = headerStyle
              headerRow.getCell(i).border = headerBorderStyle
              headerRow.getCell(i).alignment = { horizontal: 'center', vertical: 'middle' }
            }

            for(let j = 4; j <= worksheet._rows.length; j++){
              for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){

                  if (j == 4 ) {
                    worksheet.getRow(j).getCell(a).fill = headerStyle
                  }
                  worksheet.getRow(j).getCell(a).border = headerBorderStyle
                  
                  // if(worksheet.getColumn(a).dataField == "useQty" || worksheet.getColumn(a).dataField == "woQty") {
                  //     worksheet.getRow(j).getCell(a).format = "#,###"
                  //     worksheet.getRow(j).getCell(a).alignment = { horizontal: 'right' }
                  // }
              }
            }
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ListPORdeliNote.xlsx');
            });
        });     

        this.grid2Instance.cancel = true;
    }
  },
  async mounted() {
    this.init()
    await this.getDelyNoList()
    await this.btnRetrieve()
    await this.btnRetrievePo()
  }
}
</script>

<style lang="scss" scoped>
.epms5010-main {
  .row__dely {
    ::v-deep {
      [role=btnRetrieve] {
        .v-btn__content {
          div, i {
            color: #0000ff !important;
          }
        }
      }
    }
  }

  ::v-deep {
    [role=btnNew], [role=btnPrint], [role=btnPrintDetail], [role=btnMakeDeliveryNote] {
      .v-btn__content {
        div, i {
          color: #0000ff !important;
        }
      }
    }

    [role=btnSave] {
      :not([disabled=disabled]) {
        .v-btn__content {
          div, i {
            color: #0000ff !important;
          }
        }
      }
    }

    [role=btnDeleteAll], [role=btnDeleteSelect] {
      :not([disabled=disabled]) {
        .v-btn__content {
          div, i {
            color: #ff0000 !important;
          }
        }
      }
    }
  }

  ::v-deep.v-input--checkbox:not(.v-input--is-disabled) {
    .v-label {
      color: black;
      font-weight: bold;
    }
  }
}
</style>